import { useEffect, useState } from "react";

/** True at ≤360px — use compactLabel so bottom-nav text isn’t truncated. */
export function useCompactNavLabel() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia("(max-width: 360px)");
    const apply = () => setCompact(Boolean(mq.matches));
    apply();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
    mq.addListener(apply);
    return () => mq.removeListener(apply);
  }, []);

  return compact;
}

/**
 * @param {{ label: string; compactLabel?: string }} item
 * @param {boolean} compact
 */
export function navItemLabel(item, compact) {
  if (compact && item.compactLabel) return item.compactLabel;
  return item.label;
}
